var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-object"},_vm._l((_vm.data),function(value,key){return _c('div',{key:key,staticClass:"json-member",class:{ collapsed: key in _vm.collapsed }},[_c('span',{staticClass:"key",on:{"click":function($event){return _vm.onClick(key)},"contextmenu":function($event){$event.preventDefault();return _vm.$emit('menu', { $event: $event,  key: key })}}},[_vm._v(_vm._s(key)+": ")]),(value !== null && typeof value === 'object')?_c('json-tree',{attrs:{"data":value},on:{"menu":function (ref) {
                var vKey = ref.key;
                var $event = ref.$event;

                return _vm.$emit('menu', { key: (key + "." + vKey), $event: $event });
},"change":function (ref) {
                var vKey = ref.key;
                var value = ref.value;

                return _vm.$emit('change', { key: (key + "." + vKey), value: value });
}}}):[_c('input',{staticClass:"value",attrs:{"step":"any","type":{ boolean: 'checkbox', number: 'number', string: 'text'}[typeof value]},domProps:{"value":value},on:{"change":function (ref) {
                var target = ref.target;

                return _vm.$emit('change', { key: key, value: ({
                    boolean: function (target) { return target.checked; },
                    number: function (target) { return +target.value; },
                    string: function (target) { return target.value; }
                }[typeof value])(target) });
}}})]],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }